import React from "react";
import { useAppContext } from "../helpers/account-context";
import { toPermalink, cleanAvailableTags, toLowercase } from "../helpers/helper";

// https://stackoverflow.com/questions/49671434/is-there-any-way-to-customize-googles-auto-complete-address-result
// https://developers.google.com/maps/documentation/javascript/examples/geocoding-place-id

// https://developers.google.com/maps/documentation/places/web-service/autocomplete#maps_http_places_autocomplete_fr-rb

const isContainTag = (tags, value) => {
  if(!tags || tags.length === 0 || !value) return false;
  return tags.map((tag)=>(toLowercase(tag))).indexOf(toLowercase(value)) >= 0;
}

const TaggableFilters = (props) => {
  const { initedData: {enabledTags, hiddenFilters}, account: {tags} } = useAppContext()
  const {
    filters,
    onChangeFilters,
    onApplyFilters,
  } = props;

  const handleClick = (tag) => {
    const { tags } = filters
    const existingTag = tags.find((t) => (t === tag.value));
    if(existingTag)  {
      const otherTags = tags.filter((t) => (t !== tag.value));
      const newFilters = {
        ...filters,
        tags: [...otherTags]
      }
      onChangeFilters({
        ...newFilters
      })
      onApplyFilters(newFilters);
    } else {
      const newFilters = {
        ...filters,
        tags: [...tags, tag.value]
      }
      onChangeFilters({
        ...newFilters
      })
      onApplyFilters(newFilters);
    }
  }
  // https://codepen.io/smithsuth/pen/VvYzZP
  const isHidden = !!hiddenFilters && (hiddenFilters.indexOf('tags') >= 0 || hiddenFilters.indexOf('all') >= 0);
  if(isHidden) return null;
  const tagOptions = cleanAvailableTags(tags, enabledTags);

  if(!tagOptions || tagOptions.length === 0) return null;
  return  (
    <div
      className={`cbmap-taggable-filters`}
    >
      {tagOptions.map((tag) => (
        <div key={tag.value} 
          onClick={e => handleClick(tag)}
          className={`cbmap-tag-filter 
                      cbmap-tag-filter_${toPermalink(tag.value)}
                      ${isContainTag(filters.tags, tag.value) ? 'is-selected' : ''}
                      `}>
          {
            !!tag.icon_url && <div className="cbmap-tag-icon">
              <img src={tag.icon_url} alt={tag.label} title={tag.label}/>
            </div>
          }
          {tag.label}
        </div>     
      ))}
    </div>);
};

export default TaggableFilters;
